import { StartingPageService } from '@alii-web/modules/starting-page/services/starting-page.service';

export const services = [StartingPageService];

export * from './starting-page.service';
